// Kept identical to the mobile app's CategoryManager.tsx so a room edited on
// either platform follows the same limits and prices.
export const CLASSIC_CATEGORIES = ["name", "animal", "place", "thing"];
export const FREE_CATEGORY_COUNT = 4;
export const MIN_CATEGORIES = 2;
export const MAX_CATEGORIES = 8;
export const MAX_CATEGORY_LENGTH = 15;

const EXTRA_CATEGORY_COSTS = [30, 35, 40, 45];

// Cost of adding a category when the list currently has `count` entries.
export const getAddCategoryCost = (count) =>
  count < FREE_CATEGORY_COUNT ? 0 : EXTRA_CATEGORY_COSTS[count - FREE_CATEGORY_COUNT] ?? 50;

export const normalizeCategory = (name) => name.trim().toLowerCase();

// Returns an error message, or "" when the list is valid to save.
export const validateCategories = (categories) => {
  const names = categories.map(normalizeCategory);
  if (names.length < MIN_CATEGORIES) return `A game needs at least ${MIN_CATEGORIES} categories.`;
  if (names.some((n) => !n)) return "Fill in or remove the empty category.";
  const seen = new Set();
  for (const n of names) {
    if (seen.has(n)) return `"${n}" is listed twice.`;
    seen.add(n);
  }
  return "";
};
